import { WrapperAmplitudeCompanyTab } from "components/company/v3/WrapperCompany";
import { CompanyQuotesTabEnum } from "components/company/v3/menu/enums";
import FiisPageLayout from "components/company/v3/layouts/FiisPageLayout";
import FiisQuotesBox from "components/company/v3/realestatefunds/boxes/FiisQuotesBox";
import SetHttpStatusCode from "lib/http/SetHttpStatusCode";
import getQueryStringValue from "lib/utils/getQueryStringValue";
import type { NextPage } from "next";
import { parseAsStringEnum, useQueryState } from "nuqs";
import NotFound from "pages/404";
import { format } from "util";
import FiiIssuerSeo from "components/company/v3/seo/FiiIssuerSeo";
import { useIntl } from "react-intl";
import { ISecurityCountry } from "types/graphqlTypes";
import IssuerHeaderByTickerSymbol from "components/issuers/IssuerHeaderByTickerSymbol";
import useSelfie from "lib/hooks/useSelfie";

interface FiisQuotesPageProps {
  tickerSymbol: string | null;
}

const FiisQuotesPage: NextPage<FiisQuotesPageProps> = function FiisQuotesPage({ tickerSymbol }) {
  const intl = useIntl();
  const [tab, setTab] = useQueryState(
    "tab",
    parseAsStringEnum<CompanyQuotesTabEnum>(Object.values(CompanyQuotesTabEnum)).withDefault(
      CompanyQuotesTabEnum.QUOTE,
    ),
  );
  const viewer = useSelfie();
  const normalizedTickerSymbol = (tickerSymbol || "").toUpperCase();

  if (!normalizedTickerSymbol || normalizedTickerSymbol.length > 8 || /^([0-9]+)$/.test(normalizedTickerSymbol)) {
    return (
      <>
        <SetHttpStatusCode httpStatus={404} />
        <NotFound />
      </>
    );
  }

  return (
    <FiisPageLayout tickerSymbol={normalizedTickerSymbol}>
      <WrapperAmplitudeCompanyTab category="FIIs" tab={tab} tickerSymbol={normalizedTickerSymbol}>
        <>
          <FiiIssuerSeo
            title={intl.formatMessage({
              defaultMessage: "Cotação",
              description: "Título da página - SEO",
              id: "d+IfD/",
            })}
          />
          {!viewer && (
            <IssuerHeaderByTickerSymbol
              country={ISecurityCountry.Br}
              tickerSymbol={normalizedTickerSymbol}
              className="pb-6"
              title={intl.formatMessage({ defaultMessage: "Cotação", id: "zV6SED" })}
              description={intl.formatMessage({
                defaultMessage: "Gráfico histórico de cotação e retorno anual dos últimos anos",
                id: "SaNBkr",
              })}
            />
          )}
          <FiisQuotesBox
            key={format("quotes/%s/%s", tickerSymbol, tab)}
            tickerSymbol={normalizedTickerSymbol}
            tab={tab}
            onChangeTab={setTab}
          />
        </>
      </WrapperAmplitudeCompanyTab>
    </FiisPageLayout>
  );
};

FiisQuotesPage.getInitialProps = async ({ query }) => ({
  tickerSymbol: getQueryStringValue(query, "tickerSymbol"),
});

export default FiisQuotesPage;
